var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.3594,
    cy: 32.3672,
    r: 32,
    fill: "#E6F4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3562 16.082C23.3764 16.082 16.0703 23.3881 16.0703 32.3679C16.0703 41.3477 23.3764 48.6538 32.3562 48.6538C41.336 48.6538 48.6421 41.3477 48.6421 32.3679C48.6421 23.3881 41.336 16.082 32.3562 16.082ZM39.4143 29.2135L31.2713 38.6092C30.9281 39.0025 30.4395 39.2381 29.9183 39.2556C29.8958 39.2556 29.8732 39.2556 29.8507 39.2556C29.3521 39.2556 28.8735 39.0577 28.5228 38.7044L24.1381 34.3197C23.404 33.5856 23.404 32.3955 24.1381 31.6614C24.8722 30.9272 26.0623 30.9272 26.7964 31.6614L29.7555 34.6179L36.5755 26.748C37.2545 25.9663 38.4396 25.8786 39.2263 26.5576C40.0081 27.2441 40.0932 28.4292 39.4143 29.2135Z",
    fill: "#2995DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.3dbc811fd2ce46ea4db530868e29640b.svg";
export { ForwardRef as ReactComponent };